import { useEffect, useState } from 'react';
import { apiModules } from '../../api/apiService';
import { Tag } from '../../api/Tag';

interface UseRecipeTagOptionsParams {
  onError: (message: string) => void;
}

const sortTagsByName = (tags: Tag[]): Tag[] =>
  [...tags].sort((left, right) => left.name.localeCompare(right.name));

const getTagLoadErrorMessage = (error: unknown): string =>
  error instanceof Error ? error.message : 'Erreur inconnue';

const useRecipeTagOptions = ({ onError }: UseRecipeTagOptionsParams) => {
  const [availableTags, setAvailableTags] = useState<Tag[]>([]);

  useEffect(() => {
    const fetchTags = async () => {
      try {
        const tags = await apiModules.tags.getTags();
        setAvailableTags(sortTagsByName(tags));
      } catch (error: unknown) {
        const errorMessage = getTagLoadErrorMessage(error);
        console.error('Erreur lors du chargement des tags:', error);
        onError(`Erreur lors du chargement des tags: ${errorMessage}`);
      }
    };

    fetchTags();
  }, [onError]);

  return {
    availableTags,
    setAvailableTags,
  };
};

export default useRecipeTagOptions;
